import { Ref } from 'vue';
import { useValidation } from '@/ui/concerns';
import { ChecklistTemplateEditable } from '@/ui/DTO';
import { validate } from '@/entities/checklistTemplate';

export function useChecklistTemplate(record: Ref<ChecklistTemplateEditable>) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation<ChecklistTemplateEditable>(validate, record);

  return {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  };
}
